import Axios from "axios";
import { json } from "body-parser";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { useAppContext } from "../../context/state";
import { storage, useRequest } from "../../utils";
var axios = require("axios");
var FormData = require("form-data");
// import "../../assets/css/plugins/forms/wizard.css";
import ScriptTag from "react-script-tag";
// const Demo = (props) => (
//   <ScriptTag
//     type="text/javascript"
//     src="../../assets/js/scripts/forms/wizard-steps.js"
//   />
// );

// var fs = require("fs");
//locall
// import "./AddProduct.css";
import utils from "../../components/toastify/toastify";

const AddTerm = (props) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [support_price, setSupport_price] = useState("");

  let history = useHistory();

  const [add_term_error, add_term_loading, add_term_data, add_term_function] =
    useRequest({
      method: "post",
      url: "/add_term",
      body: {
        product_id: props.match.params.id,
        title,
        description,
        price,
        support_price,
      },
      isFunction: true,
    });

  return (
    <div className="AddProductContainer">
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">مسیر</h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">افزودن محصول جدید</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Wizard /> */}
      {/* <!-- Basic Inputs start --> */}
      <section id="basic-input">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header">
                <h4 class="card-title">افزودن ترم جدید</h4>
              </div>

              <div class="card">
                {/* <div class="card-header">
                  <h4 class="card-title">ترم ها</h4>
                </div> */}
                <div class="card-content">
                  <div class="card-body">
                    <form action="#" class="contact-repeater">
                      <div data-repeater-list="contact">
                        <div
                          class="row justify-content-between"
                          data-repeater-item
                        >
                          <div class="col-md-6 col-12 form-group d-flex align-items-center">
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  marginBottom: "10px",
                                }}
                              >
                                <input
                                  type="text"
                                  class="form-control"
                                  placeholder="عنوان ترم"
                                  value={title}
                                  onChange={(e) => setTitle(e.target.value)}
                                />
                              </div>
                              <input
                                type="text"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="توضیح یک خطی ترم"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                              />
                              <input
                                type="number"
                                style={{
                                  marginBottom: "10px",
                                }}
                                class="form-control"
                                placeholder="مبلغ ترم"
                                value={price}
                                onChange={(e) => setPrice(e.target.value)}
                              />
                              <input
                                type="number"
                                class="form-control"
                                placeholder="مبلغ پشتیبانی"
                                value={support_price}
                                onChange={(e) =>
                                  setSupport_price(e.target.value)
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <button
                onClick={() => {
                  var $white = "#fff";
                  $.blockUI({
                    message:
                      '<div class="semibold"><span class="bx bx-reset icon-spin text-left align-middle" style="padding-bottom:1.75px"></span>&nbsp; در حال انجام عملیات ...</div>',

                    // timeout: 2000, //unblock after 2 seconds
                    overlayCSS: {
                      backgroundColor: $white,
                      opacity: 0.8,
                      cursor: "wait",
                    },
                    css: {
                      border: 0,
                      padding: 0,
                      backgroundColor: "transparent",
                    },
                  });
                  add_term_function()
                    .then(() => {
                      history.push("/dashboard/terms/" + props.match.params.id);
                      $.unblockUI();
                    })
                    .catch(() => {
                      utils.showAlert("خطایی به وجود آمده است", "error");
                      $.unblockUI();
                    });
                }}
                style={{
                  marginTop: "-2rem",
                  marginRight: "25px",
                  width: "fit-content",
                }}
                type="button"
                class="btn btn-success mr-1 mb-1 "
              >
                افزودن ترم جدید
              </button>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Basic Inputs end --> */}
      {/* <Demo /> */}
    </div>
  );
};

export { AddTerm };
